import { gql } from '@apollo/client'

export const SEND_FORWARDING_SMS = gql`
  mutation sendForwardingSms($processingId: ID!, $smsText: String!) {
    sendForwardingSms(processingId: $processingId, smsText: $smsText)
  }
`
